<template>
  <div class="container">
    <div class="inner-container">
      <div class="bazzi" v-if="!모달등장">
        <img src="./assets/bazzi.png" @click="두드려" width="180" class="mb-3">
      </div>

      <div class="inputbox container fade-in" v-if="모달등장">
        <div class="input-group mb-3">
          <span class="input-group-text">할말</span>
          <input type="text" class="form-control" v-model="할말입력">
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text">링크</span>
          <input type="text" class="form-control" v-model="링크입력">
        </div>

        <div class="button-group">
          <button class="btn btn-reset" @click="초기화">초기화</button>
          <button class="btn btn-gold" @click="등록">등록</button>
          <button class="btn btn-light" @click="모달등장 = false">취소</button>
        </div>
      </div>

      <div class="링크박스모음">
        <div class="골본대화링크 p-3 border border-4 rounded mb-3">
          <h3>골드본좌 1:1 카톡방</h3>
          <a href="https://open.kakao.com/o/sjKlWb9g" target="_blank" @click="추가입장()">
            <button class="btn btn-gold">카톡 대화방 입장</button>
          </a>
          <p class="pt-2 mb-0">총 {{ 입장 }}명이 말을 걸고 감</p>
        </div>
      </div>
      
      <div class="이벤트링크 p-3 border border-4 rounded mb-3">
        <h3>{{ 할말 }}</h3>
        <a :href='링크' target="_blank" class=""><button class="btn btn-gold">링크 이동</button></a>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from './main.js'

export default {
  name: 'App',
  data() {
    return {
      할말입력: '',
      링크입력: '',
      모달등장: false,
      터치수: 0,
      입장: 0,
      초기화할말: '카러플갤러리',
      초기화링크: 'https://gall.dcinside.com/mgallery/board/lists/?id=kartriderplus',
    }
  },
  methods: {
    초기화() {
      this.할말입력 = this.초기화할말;
      this.링크입력 = this.초기화링크;
    },
    추가입장() {
      this.입장++;
      db.collection('link').doc('link').update({ visit: this.입장 });
    },
    두드려() {
      this.터치수++;
      if (this.터치수 == 5) {
        this.모달등장 = true;
        this.터치수 = 0;
      }
    },
    등록() {
      db.collection('link').doc('link').update({
        link: this.링크입력 || this.링크,
        msg: this.할말입력,
      }).then(() => {
        location.reload();
      });
    },
  },
  mounted() {
    db.collection('link').doc('link').onSnapshot((e) => {
      this.링크 = e.data().link;
      this.할말 = e.data().msg;
      this.입장 = e.data().visit;
    });
  }
}
</script>

<style>
#app {
  font-family: "Noto Sans KR", Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
}

.container {
  max-width: 500px;
  margin: auto;
}

.clickable-image {
  width: 150px;
  cursor: pointer;
  transition: transform 0.3s;
}
.clickable-image:hover {
  transform: scale(1.1);
}

.inputbox {
  background: #fffbe6;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease-in-out;
}

.fade-in {
  animation: fadeIn 0.5s ease-in;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn {
  border-radius: 10px;
  width: 80%;
  padding: 10px 20px;
  font-size: 16px;
  transition: 0.3s;
}
.btn:hover {
  opacity: 0.8;
}

.btn-gold {
  background: linear-gradient(135deg, #ffcc00, #ff9900);
  color: white;
  border: none;
}

.btn-light {
  background: #f4f4f4;
  color: #333;
  border: 1px solid #ccc;
}

.btn-reset {
  background: #ff4d4d;
  color: white;
  border: none;
}

.link {
  font-size: large;
  font-weight: bold;
}

.link-button {
  display: inline-block;
  padding: 10px 20px;
  background: linear-gradient(135deg, #ffcc00, #ff9900);
  color: white;
  border-radius: 20px;
  text-decoration: none;
  transition: 0.3s;
}

.link-button:hover {
  opacity: 0.8;
}
</style>